import React, { useState, ReactElement, useEffect } from "react";
import classnames from "classnames";
import { Icon, Drawer } from "@/components";
import { i18n, priceFormat } from "@/utils";
import { VipIncrement } from "../../../increment/increment";
import styles from "./style.less";
import { Type } from ".././factory/spotify-code-film";
import { Shop } from "@/sunzi";

interface VipProps {
  /** 店铺 */
  shop: Shop;
  className?: string;
  /** 产品信息 */
  productContent?: ReactElement;
  /** vip 增值服务 */
  vipIncrement?: VipIncrement;
  /** 钱符号 */
  currencySymbol?: string;
  /** 是否展示遮罩 */
  mask?: boolean;
  /** 礼物盒 */
  giftBoxs: Type[];
  /** 关闭回调 */
  onClose: () => void;
  /** 确认回调 */
  onConfirm: (vipIncrement?: VipIncrement, giftBox?: Type) => void;
  /** 谷歌分析 */
  gtag?: any;
}

const GiftDrawer: React.FC<VipProps> = ({
  shop,
  className,
  productContent,
  vipIncrement,
  currencySymbol,
  mask,
  giftBoxs,
  onClose,
  onConfirm,
  gtag,
}) => {
  console.log("giftBoxs", giftBoxs);
  const [giftIndex, setGiftIndex] = useState<number>(0);

  return (
    <div className={styles.drawerWrapper}>
      <Drawer mask={true}>
        <div className={styles.drawerBox}>
          <div className={classnames(styles.header)}>
            <div className={styles.text}>
              <span>{"Add a package"}</span>
            </div>
            <div className={styles.close} onClick={onClose}>
              <Icon type="close" size={25} />
            </div>
          </div>
          {giftBoxs && (
            <div className={styles.giftPreview}>
              <div className={styles.giftPreviewBox}>
                <div className={styles.giftBox}>
                  {giftBoxs?.map((item, index) => {
                    return (
                      <div className={styles.giftItem} key={index}>
                        <div
                          className={classnames(styles.imgBox, {
                            [styles.active]: giftIndex == index,
                          })}
                          onClick={() => setGiftIndex(index)}
                        >
                          <div
                            className={classnames(styles.giftImg, {})}
                            style={{ backgroundImage: `url(${item.url})` }}
                          ></div>
                          {/* {giftIndex == index && (
                            <div className={styles.activeIcon}>
                              <Icon type="active" size={25} color="#FF533A" />
                            </div>
                          )} */}
                          <div className={styles.giftItemText}>{item.name}</div>
                          <div className={styles.giftItemPrice}>
                            {"+" + priceFormat(shop.currencySymbol, item.price)}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}

          <div className={classnames(styles.buttonBox)}>
            <div
              className={styles.button}
              onClick={() =>
                onConfirm(
                  undefined,
                  giftIndex === -1 ? undefined : giftBoxs![giftIndex]
                )
              }
            >
              <div className={styles.addCartIcon}>
                <Icon type="shop-cart" size={25} color={'#fff'}/>
              </div>
              {"+" +
                priceFormat(
                  shop.currencySymbol,
                  giftBoxs[giftIndex]?.price
                )}{" "}
              Add to cart
            </div>
            <div
              className={styles.button2}
              onClick={() =>
                onConfirm()
              }
            >
              No thanks & Add To Cart
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default GiftDrawer;
